import { forwardRef } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import Dialog from '@mui/material/Dialog';
import { Box, makeStyles, Typography, Button } from '@material-ui/core';
import Slide from '@mui/material/Slide';
import { useNavigate } from 'react-router';

import { ROUTES_AUTHEN } from 'src/constants';

const useStyles = makeStyles((theme) => ({
  dialogContainer: {
    padding: '1.5rem 4rem',
    [theme.breakpoints.down(700)]: {
      padding: '1.5rem 3rem'
    }
  },
  title: {
    margin: '1rem 0 3rem',
    padding: '0 3rem',
    '& h5': {
      fontWeight: '600'
    },
    [theme.breakpoints.down(700)]: {
      padding: '0 2rem'
    }
  },
  wrapButton: {
    display: 'flex',
    justifyContent: 'center',
    margin: '5rem 0',
    [theme.breakpoints.down(700)]: {
      flexDirection: 'column',
      margin: '2rem 0'
    }
  },
  buttonBack: {
    backgroundColor: '#A7A7A7 !important',
    color: '#fff !important'
  },
  buttonDelete: {
    backgroundColor: 'black !important',
    color: '#fff !important'
  },
  button: {
    padding: '12px 0 !important',
    borderRadius: 0,
    width: '100%',
    color: '#fff !important',
    '&:hover': {
      backgroundColor: '#1175ae'
    }
  }
}));

export default function DeleteDialog({ open, onClose }) {
  const classes = useStyles();
  const navigate = useNavigate();

  const handleClose = () => {
    onClose(false);
  };

  return (
    <Dialog
      TransitionComponent={Transition}
      onClose={handleClose}
      open={open}
      aria-describedby="alert-dialog-slide-description"
    >
      <Box className={clsx(classes.dialogContainer)}>
        <Box className={clsx(classes.title)}>
          <Typography variant="h5">本当に退会しますか？</Typography>
        </Box>

        <Box mt={2}>
          <Button
            onClick={() => navigate(ROUTES_AUTHEN.MY_PAGE)}
            className={clsx(classes.button, classes.buttonBack)}
          >
            マイページに戻る
          </Button>
        </Box>
        <Box mt={2}>
          <Button
            type="submit"
            form="delete"
            className={clsx(classes.button, classes.buttonDelete)}
          >
            退会する
          </Button>
        </Box>
      </Box>
    </Dialog>
  );
}

DeleteDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired
};

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
